﻿import { FIQAssist } from "../app";
import { Component, Input, Output, Binding, Attribute, Inject } from "@fiqas/angular-utils";
import { KeyCodes, KeyboardEventCode } from "@fiqas/utils";

@Component({
    module: FIQAssist,
    selector: 'numbereditbox',
    template: `<div class="numbereditboxframe {{$ctrl.childClasses}} ng-class:{candelete:$ctrl.candelete, hasfocus:$ctrl._hasFocus, 'has-value': $ctrl.hasValue, error: $ctrl.showError, readonly:$ctrl.readOnly }">
                <div class="placeholder">
                  <span class="placeholder-number unselectable" ng-hide="$ctrl.hasValue">{{$ctrl._displayedHint | translate}}</span>
                  <input ng-keydown="$ctrl.onKey($event)" ng-readonly="$ctrl.readOnly" type="text"
                    ng-change="$ctrl.onChange()" ng-focus="$ctrl.onFocus();" ng-blur="$ctrl.onBlur()"
                    class="numbereditbox" ng-model="$ctrl.value"
                    ng-model-options="{ debounce: { 'default': $ctrl.debounce, 'blur':0 }}" />
                </div>
                <span class="mandatory-dot" ng-if="$ctrl.mandatory" uib-tooltip="{{'FIELD_REQUIRED_TOOLTIP' | translate}}" tooltip-placement="top" tooltip-class="customTooltipTB"></span>
                <div ng-click="$ctrl.ClearField()" class="clearfield-icon">
                    <span class="icon-clearField"></span>
                </div>
            </div>`
})
export class NumberEditBox {
    private _value: string;
    private _hint: string;
    private _displayedHint: string;
    private _hasFocus: boolean = false;
    private wasFocused: boolean = false;
    private _dirty: boolean = false;

    @Input() public readOnly: boolean;

    constructor(
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$element') private $element: angular.IRootElementService) {
    }

    private get hasValue() {
        return this._value !== null && this._value !== undefined && this._value !== "" && this._value !== " ";
    }

    private get showError() {
        return this.mandatory && ((!this._hasFocus && this.wasFocused && !this.hasValue) || (!this._hasFocus && this.iserror));
    }

    private _childClasses;
    @Attribute() public get childClasses() {
        return this._childClasses;
    }
    public set childClasses(val: string) {
        this._childClasses = val;
    }

    private _mandatory;
    @Attribute() public get mandatory() {
        return this._mandatory;
    }
    public set mandatory(val: boolean | string) {
        this._mandatory = val === true || val === "true";
    }
    @Input() public active: boolean;
    @Input() public get value() {
        return this._value;
    }
    public set value(val: string) {
        val = typeof val === 'string' ? val.replace(/[^-0-9]+/g, '') : val;
        if (val != this._value) {
            this._value = val;
            if (!this.changeonblur) {
                this.valueChanged({ value: this._value });
            } else {
                this._dirty = true;
            }
        }
    }

    @Input()
    public get hint(): string {
        return this._hint;
    }
    public set hint(theHint: string) {
        this._hint = theHint;
        this._displayedHint = this._hasFocus ? '' : this._hint;
    }

    @Input() public focusinput: boolean;
    @Input() public candelete: boolean;
    @Input() public iserror: boolean;
    @Input() public changeonblur: boolean = false;

    @Input() public debounce: number = 0;

    @Output() public valueChanged: (args: { value: string }) => void;
    @Output() public valueSubmit: (args: { value: string }) => void;

    private onKey($event: KeyboardEvent) {
        if (
            ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-'].indexOf($event.key) > -1
            || $event.which >= 48 && $event.which <= 57
            || $event.which === 0 && $event.charCode === 0
            || $event.keyCode === KeyCodes.backspace
            || $event.keyCode === KeyCodes.tab
            || $event.keyCode === KeyCodes.home
            || $event.keyCode === KeyCodes.end
            || $event.keyCode === KeyCodes.leftArrow
            || $event.keyCode === KeyCodes.rightArrow
            || $event.keyCode === KeyCodes.upArrow
            || $event.keyCode === KeyCodes.downArrow
            || $event.keyCode === KeyCodes.delete
            || $event.code === KeyboardEventCode.backspace
            || $event.code === KeyboardEventCode.tab
            || $event.code === KeyboardEventCode.home
            || $event.code === KeyboardEventCode.end
            || $event.code === KeyboardEventCode.leftArrow
            || $event.code === KeyboardEventCode.rightArrow
            || $event.code === KeyboardEventCode.upArrow
            || $event.code === KeyboardEventCode.downArrow
            || $event.code === KeyboardEventCode.delete
            || $event.keyCode === KeyCodes.subtract
            || $event.keyCode === KeyCodes.dash
            || $event.keyCode === KeyCodes.numpad1
            || $event.keyCode === KeyCodes.numpad2
            || $event.keyCode === KeyCodes.numpad3
            || $event.keyCode === KeyCodes.numpad4
            || $event.keyCode === KeyCodes.numpad5
            || $event.keyCode === KeyCodes.numpad6
            || $event.keyCode === KeyCodes.numpad7
            || $event.keyCode === KeyCodes.numpad8
            || $event.keyCode === KeyCodes.numpad9
            || $event.keyCode === KeyCodes.numpad0
            || (
                ['z', 'x', 'c', 'v', 'a'].indexOf($event.key) > -1
                || $event.keyCode === KeyCodes.a
                || $event.keyCode === KeyCodes.v
                || $event.keyCode === KeyCodes.c
                || $event.keyCode === KeyCodes.x
                || $event.keyCode === KeyCodes.z
            ) && ($event.ctrlKey || $event.metaKey)
        ) {
            // to allow numbers
            return true;
        } else if ($event.keyCode === KeyCodes.enter) {
            $event.preventDefault();
            this.valueSubmit({ value: this._value });
            return false;
        } else {
            // to stop others
            $event.preventDefault();
            return false;
        }
    }

    private onFocus() {
        this._hasFocus = this.wasFocused = true;
    }

    private onBlur() {
        this._hasFocus = false;
        if (!this.hasValue)
            this._displayedHint = this._hint;
        if (this.readOnly)
            return;
        if (this.changeonblur && this._dirty) {
            this._dirty = false;
            this.valueChanged({ value: this._value });
        }
    }

    private onChange(event: any) {
        if (this.readOnly)
            return;
        if (this.changeonblur) {
            this._dirty = true;
        } else {
            this.valueChanged({ value: this._value });
        }
    }

    async $postLink() {
        if (this.focusinput) {
            await this.$timeout(25);
            this.focusField();
        }
    }

    private focusField() {
        var element = this.$element;
        var field = (<any>element[0].getElementsByClassName('numbereditarea').item(0));
        if (field)
            field.focus();
    }

    public ClearField() {
        if (this.readOnly || !this.candelete)
            return;

        this.focusField();
        this._value = '';
        this.valueChanged({ value: this._value });
    }
}
